import React from 'react'

import clsx from 'clsx'

import { Divider } from '@material-ui/core'

const getVerticalDivider = ( { className = null , Component = Divider, key=undefined , props = { light:true } } = {} ) => <Component key={key} orientation='vertical' flexItem className={ clsx('mx-8',className) } { ...props } /> ;

export default getVerticalDivider ;
